import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CookieModule } from 'ngx-cookie';
import { GravatarModule } from 'ngx-gravatar';

import { FeatureFlagDirective, MixpanelEventsDirective, UserPermissionsDirective } from '@bn/shared/directives';
import { LazyLoadDirective, MarkAllTouchedDirective } from '@bn/web-ui';
import { AlertComponent } from '@bn/web-ui/alert/alert.component';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { CheckboxComponent } from '@bn/web-ui/checkbox/checkbox.component';
import { InputComponent } from '@bn/web-ui/input/input.component';
import { FormcontrolErrorsComponent } from '@bn/web-ui/standalone/formcontrol-errors/formcontrol-errors.component';

import { AuthRoutingModule } from './auth-routing.module';
import { CaptchaComponent, RegisterSliderComponent } from './components';
import { ContentSliderComponent } from './components/content-slider/content-slider.component';
import { AuthLayoutComponent } from './layout/auth-layout.component';
import { EmailConfirmedPage, LoginPage, RegisterPage, ResetPasswordPage, TwoFactorAuthPage } from './pages';

@NgModule({
  imports: [
    CommonModule,
    CookieModule.withOptions(),
    CaptchaComponent,
    RegisterSliderComponent,
    RouterModule,
    AuthRoutingModule,
    GravatarModule,
    AlertComponent,
    ButtonComponent,
    CheckboxComponent,
    ContentSliderComponent,
    FormcontrolErrorsComponent,
    InputComponent,
    FaIconComponent,
    LazyLoadDirective,
    MarkAllTouchedDirective,
    ReactiveFormsModule,
    FeatureFlagDirective,
    UserPermissionsDirective,
    AuthLayoutComponent,
    ResetPasswordPage,
    TwoFactorAuthPage,
  ],
  declarations: [EmailConfirmedPage, LoginPage, RegisterPage],
  providers: [MixpanelEventsDirective],
  exports: [FeatureFlagDirective, UserPermissionsDirective],
})
export class AuthModule {}
